import { ErrorIcon } from '@/assets/icons';

type ApplicantErrorLabelProp = {
  title: React.ReactNode;
  subtitle: string;
};
export const ApplicantErrorLabel = ({
  title,
  subtitle,
}: ApplicantErrorLabelProp) => {
  return (
    <div className="flex flex-row flex-wrap content-center gap-2 rounded-xl border border-transparent bg-[#FEE2E2] p-4">
      <div className="self-center">
        <ErrorIcon className="size-6" />
      </div>
      <div className="flex flex-col gap-1">
        <div>{title}</div>
        <div>
          <span>{subtitle}</span>
        </div>
      </div>
    </div>
  );
};
